import { useTranslation } from "react-i18next";

export default function SurveyThankYou({ firstName }) {
    const { t } = useTranslation();

    return (
        <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-violet-500/10 border border-violet-500/30 flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-violet-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <h2 className="text-2xl font-bold text-white mb-3">
                {t("survey.thankYouTitle")}
            </h2>
            <p className="text-white/50 text-lg">
                {t("survey.thankYouBody", { firstName: firstName || t("survey.defaultName") })}
            </p>
        </div>
    );
}
